import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  redirectInfo: {},
};

const deeplinkSlice = createSlice({
  name: 'deeplink',
  initialState,
  reducers: {
    setRedirectInfo: (state, action) => {
      state.redirectInfo = action.payload;
    },
  },
});

export const { setRedirectInfo } = deeplinkSlice.actions;

export default deeplinkSlice.reducer;